export const perPageOptionsList = [2, 4, 6];

export const TABLE_ENTITY_NAME = "logs-activity-table";

export const noContentFound = "No Logs to show";
export const fetchingErrorText = "Error occurs, please try again later";

export const reconfiguredText = "Reconfigured";
